import React from 'react';
import { Box, Typography, Container, Accordion, AccordionSummary, AccordionDetails, useTheme } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FAQSection = () => {
    const theme = useTheme();

    return (
        <Box sx={{ backgroundColor: theme.palette.background.default, padding: theme.spacing(8, 2) }}>
            <Container>
                <Typography
                    variant="h3"
                    sx={{
                        fontWeight: 700,
                        textAlign: 'center',
                        marginBottom: theme.spacing(4),
                        fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                    }}
                >
                    Frequently Asked Questions
                </Typography>

                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 400,
                        textAlign: 'center',
                        marginBottom: theme.spacing(6),
                        fontSize: { xs: '1rem', sm: '1.25rem' },
                    }}
                >
                    Here are some common questions answered. For more details, visit our <a href="/faq" style={{ textDecoration: 'none', color: theme.palette.primary.dark }}>FAQ page</a>.
                </Typography>

                {/* FAQ Accordion */}
                <Accordion sx={{ marginBottom: theme.spacing(2) }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} id="faq1-header">
                        <Typography variant="h6">What is Glassyfied?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body1">
                            Glassyfied is a web app designed to help students, educators, and academic professionals by providing detailed answers, notes, and resources through AI tools like OpenAI and Gemini.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion sx={{ marginBottom: theme.spacing(2) }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} id="faq2-header">
                        <Typography variant="h6">How do I ask a question?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body1">
                            Simply type your question in the chat interface, and Glassyfied will provide an instant response. You can ask about any subject or topic!
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion sx={{ marginBottom: theme.spacing(2) }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} id="faq3-header">
                        <Typography variant="h6">Can I upload images?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body1">
                            Yes! You can upload images, and Glassyfied will extract relevant content from the image for analysis and provide answers based on it.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion sx={{ marginBottom: theme.spacing(2) }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} id="faq4-header">
                        <Typography variant="h6">Can I create notes?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body1">
                            Absolutely! You can generate and save notes directly in the app. Keep them organized for later use or reference.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion sx={{ marginBottom: theme.spacing(2) }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} id="faq5-header">
                        <Typography variant="h6">How do I access more FAQs?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body1">
                            For more detailed answers, visit our full FAQ page by clicking the link above.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Container>
        </Box>
    );
};

export default FAQSection;
